<template>
  <div class="compar-results-wrap">
    <div class="location-box" id="locationBox" style="display: none;">
      <div class="top-list-box">
        <div class="top-item"></div>
        <div class="top-item" 
          v-for="item in comparResultList" 
          :key="item.mealId">
          <div class="name">{{ item.mealName }}</div>
          <div class="num">项目数量：{{ item.quantity }}</div>
          <div class="price">
            <span class="fz28">￥</span>
            <span>{{ item.price }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="w1200">
      <div class="compar-header">
        <span>体检套餐 </span>
        <span class="blue">对比结果</span>
      </div>
      <div class="compar-tips">
        温馨提醒：以下对比结果仅供参考，并不说明该结果决定体检套餐的丰富度，所以请您根据自身情况选择。
      </div>
      <div class="compar-list">
        <div class="compar-item" 
          v-for="item in comparResultList" 
          :key="item.mealId">
          <div class="top-box"></div>
          <div class="compar-name">{{ item.mealName }}</div>
          <div class="compar-num">项目数量{{ item.quantity }}</div>
          <div class="compar-price">
            <span class="fz28">￥</span>
            <span>{{ item.price }}</span>
          </div>
        </div>
      </div>
      <div class="compar-name-list">
        <div class="pl145"></div>
        <div class="compar-name-item" 
          v-for="item in comparResultList" 
          :key="item.mealId">
          {{ item.mealName }}
        </div>
      </div>
      <!-- 机构信息 -->
      <div class="institutional-info-box">
        <div class="institutional-top">
          <img src="@/assets/img/welfareMall/healthCheck/institution.png" alt="">
          <div class="institutional-header">机构信息</div>
        </div>
        <div class="institutional-list">
          <div class="item-name">机构名称</div>
          <div class="item-value" 
            v-for="item in comparResultList" 
            :key="item.mealId">
              {{ item.mealOrganization.hospName }}
          </div>
        </div>
        <div class="institutional-list">
          <div class="item-name">机构等级</div>
          <div class="item-value" 
            v-for="item in comparResultList" 
            :key="item.mealId">
              {{ item.mealOrganization.hospRank }}
          </div>
        </div>
        <div class="institutional-list">
          <div class="item-name">体检时间</div>
          <div class="item-value" 
            v-for="item in comparResultList" 
            :key="item.mealId">
              {{ item.mealOrganization.hospWorkTime }}
          </div>
        </div>
        <div class="institutional-list">
          <div class="item-name">预约通知</div>
          <div class="item-value" 
            v-for="item in comparResultList" 
            :key="item.mealId">
              {{ item.mealOrganization.notificationTime }}
          </div>
        </div>
        <div class="institutional-list">
          <div class="item-name">机构地址</div>
          <div class="item-value" 
            v-for="item in comparResultList" 
            :key="item.mealId">
              {{ item.mealOrganization.hospAddress }}
          </div>
        </div>
      </div>
      <!-- 套餐项目 -->
      <div class="package-box">
        <div class="package-top">
          <div class="left">
            <img src="@/assets/img/welfareMall/healthCheck/package.png" alt="">
            <div class="package-header">套餐项目</div>
          </div>
          <div class="right">
            --表示无体检项目
          </div>
        </div>
        <div class="package-list">
          <div 
            class="package-item"
            v-for="(it,idx) in mealInfoList" 
            :key="idx">
            <div class="item-name">{{ it.paramName }}</div>
            <div class="item-value" v-for="child in it.children" :key="child.mealId">
                <div class="have" v-if="child.isShow">
                  <img src="@/assets/img/welfareMall/healthCheck/have-icon.png" alt="">
                </div>
                <div class="not-have" v-else>--</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetReqComparList } from "network/welfareMall_api.js";
export default {
  name: "ComparisonResults",
  data() {
    return {
      mealIds: '',
      comparResultList: [],
      mealInfoList:[]
    }
  },
  created(){
    let { mealIds } = this.$route.query;
    this.mealIds = mealIds;
    if(this.mealIds){
      this.getComparList(this.mealIds);
    }
  },
  mounted(){
    this.initScroll();
  },
  methods:{
    async getComparList(mealIds){
      let res = await GetReqComparList(mealIds);
      if(res.isSuccess){
        this.comparResultList = res.data.map(item => ({
          ...item,
          quantity: (item.mealInfo.filter(it => it.isShow)).length
        }));
        const mealInfoList = [];
        // 遍历所有的 mealInfo
        res.data.forEach(meal => {
          meal.mealInfo.forEach(info => {
            // 检查mealInfoList中是否已存在相同的paramName
            const existingItem = mealInfoList.find(item => item.paramName === info.paramName);
            
            if (existingItem) {
              // 如果已经存在，添加新的mealId和isShow
              existingItem.children.push({
                mealId: meal.mealId,
                isShow: info.isShow
              });
            } else {
              // 如果没有找到，创建新的项并添加
              mealInfoList.push({
                paramName: info.paramName,
                mealId: meal.mealId,
                children: [{
                  mealId: meal.mealId,
                  isShow: info.isShow
                }]
              });
            }
          });
        });
        this.mealInfoList = mealInfoList;
      }else{
        this.$message.error(res.msg);
      }
    },
    initScroll() {
      const locationBox = document.getElementById('locationBox');
      let offsetTop = locationBox.offsetTop; // 获取 div 初始位置
      const threshold = 387; // 距离阈值
      let timeout = null; // 防抖定时器
      console.log('offsetTop',offsetTop)
      window.addEventListener('scroll', function() {
        if (timeout) {
          clearTimeout(timeout);
        }
        timeout = setTimeout(function() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          console.log('scrollTop',scrollTop)
          const shouldFix = scrollTop > offsetTop + threshold;
          if (shouldFix) {
            if (locationBox.style.position !== 'fixed') {
              locationBox.style.position = 'fixed';
              locationBox.style.top = '70px';
              locationBox.style.display = 'block'; // 确保元素显示
            }
          }else{
            if (locationBox.style.position !== '') {
              locationBox.style.position = '';
              locationBox.style.top = '';
              locationBox.style.display = 'none'; // 隐藏元素
            }
          }
        }, 100); 
      });
    }
  }
}
</script>
<style lang="less" scoped>
.compar-results-wrap{
  width: 100%;
  .location-box{
    width: 100%;
    height: 210px;
    z-index:100;
    box-shadow: 0px 3px 8px 1px rgba(0,0,0,0.08);
    background-color: #FFFFFF;
    .top-list-box{
      display: flex;
      width: 1200px;
      height: 210px;
      margin: 0 auto;
      z-index:100;
      .top-item{
        position: relative;
        box-sizing: border-box;
        padding: 30px 0;
        height: 210px;
        flex: 1;
        .name{
          text-align: center;
          font-weight: bold;
          font-size: 22px;
          color: #333333;
          line-height: 30px;
          margin-bottom: 20px;
        }
        .num{
          text-align: center;
          font-weight: 400;
          font-size: 18px;
          color: #333333;
          margin-bottom: 30px;
        }
        .price{
          text-align: center;
          font-weight: bold;
          font-size: 36px;
          color: #FF8000;
          .fz28{
            font-size: 28px;
          }
        }
      }
      .top-item:not(:first-child):not(:last-child)::after {
        content: '';
        display: block;  
        width: 1px;  
        height: 80px; 
        background-color: #EDEEEE;  
        position: absolute;
        top: 50%;
        right: 0;  
        transform: translateY(-50%);
      }
    }
  }
  .w1200{
    width: 1200px;
    margin: 0 auto;
    .compar-header{
      margin-top: 102px;
      width: 100%;
      text-align: center;
      color: #242638;
      font-weight: 500;
      font-size: 52px;
      height: 72px;
      line-height: 72px;
      margin-bottom: 30px;
      .blue{
        color: #1181FE;
      }
    }
    .compar-tips{
      height: 25px;
      line-height: 25px;
      font-weight: 500;
      font-size: 18px;
      color: #888888;
      text-align: center;
      margin-bottom: 60px;
    }
    .compar-list{
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
      .compar-item{
        position: relative;
        width: 380px;
        height: 230px;
        background: #FFFFFF;
        box-shadow: 0px 2px 8px 1px rgba(0,0,0,0.08);
        border-radius: 30px 30px 30px 30px;
        margin-bottom: 60px;
        text-align: center;
        padding: 39px;
        &:nth-child(2){
          .top-box{
            background-color: #68D279 !important;
          }
        }
        &:nth-child(3){
          .top-box{
            background-color: 00CBFF !important;
          }
        }
        .top-box{
          position: absolute;
          top: -4px;
          left: 160px;
          width: 90px;
          height: 8px;
          background-color: #FFB300;
          border-radius: 16px 16px 16px 16px;
        }
        .compar-name{
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          line-height: 30px;
          margin-bottom: 20px;
        }
        .compar-num{
          font-weight: 400;
          font-size: 18px;
          color: #333333;
          margin-bottom: 30px;
        }
        .compar-price{
          font-weight: bold;
          font-size: 36px;
          color: #FF8000;
          .fz28{
            font-size: 28px;
          }
        }
      }
    }
    .compar-name-list{
      display: flex;
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      line-height: 30px;
      margin-bottom: 30px;
      .pl145{
        padding-left: 145px;
      }
      .compar-name-item{
        flex: 1;
        text-align: center;
      }
    }
    // 机构信息
    .institutional-info-box{
      .institutional-top{
        display: flex;
        padding: 30px 0;
        border-top: 1px solid #EDEEEE;
        border-bottom: 1px solid #EDEEEE;
        img{
          padding-left: 20px;
        }
        .institutional-header{
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          margin-left: 10px;
        }
      }
      .institutional-list{
        display: flex;
        // height: 64px;
        min-height: 64px;
        line-height: 64px;
        .item-name{
          font-weight: bold;
          font-size: 16px;
          color: #333333;
          width: 145px;
          // padding-left: 30px;
          text-align: center;
          border-left: 1px solid #EDEEEE;
          border-right: 1px solid #EDEEEE;
          border-bottom: 1px solid #EDEEEE;
        }
        .item-value{
          flex: 1;
          text-align: center;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          border-right: 1px solid #EDEEEE;
          border-bottom: 1px solid #EDEEEE;
        }
      }
    }
    // 套餐项目
    .package-box{
      .package-top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 90px;
        border-top: 1px solid #EDEEEE;
        border-bottom: 1px solid #EDEEEE;
        padding-right: 15px;
        .left{
          display: flex;
          img{
            padding-left: 20px;
          }
          .package-header{
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            margin-left: 10px;
          }
        }
        .right{
          font-weight: 400;
          font-size: 16px;
          color: #9A9A9A;
        }
      }
      .package-list{
        margin-bottom: 100px;
        .package-item{
          display: flex;
          min-height: 65px;
          line-height: 65px;
          .item-name{
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            text-align: center;
            flex: 1;
            border-left: 1px solid #EDEEEE;
            border-right: 1px solid #EDEEEE;
            border-bottom: 1px solid #EDEEEE;
          }
          .item-value{
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            border-right: 1px solid #EDEEEE;
            border-bottom: 1px solid #EDEEEE;
            .have{
              width: 29px;
              height: 29px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .not-have{

            }
          }
        }
      }
    }
  }
}
</style>